/** 工单列表中需要获取的工单的代码 */
export const catalogCodeArr = ["cesfwb", "WYBX", "WYTS", "XQTB", "TCWSQ", "yykf", "ZCZX", "fuwcp", "fuwsl", "YQZX", "YJFK", "FKYY_sfz", "FKYY_fk"]; // myservice要显示的工单类型

/** 工单列表中，当选择全部时，获取的工单的代码 */
export const catalogCodeString = "cesfwb,fuwsl,fuwcp,yykf,TCWSQ,WYBX,XQTB,WYTS,ZCZX,YQZX,YJFK,FKYY_sfz,FKYY_fk";
